import { useState, useEffect, useRef } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import styles from "../../../ResetPin/resetPin.module.css"; // Import CSS module
import checkmark from '../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/check.png'
import knowioLogo from '../../../assets/knowio-logo.png'
import parfasLogo from '../../../assets/parfas-logo.png'
import portalLogo from '../../../assets/portal-logo.png'
import magnumLogo from '../../../assets/magnum-logo.png'
import resureLogo from '../../../assets/resure-logo.png'
import eesLogo from '../../../assets/ees-logo.png'
import solarLogo from '../../../assets/solar-logo.png'
import cscLogo from '../../../assets/csc-logo.png'
import siteGuardLogo from '../../../assets/siteguard-logo.png'
import siteGuardianLogo from '../../../assets/siteguardian-logo.png'
import crimeGuardLogo from '../../../assets/crimeguard-logo.png'
import redLogo from '../../../assets/red-logo.png'

import { set } from "date-fns";

const PortalPasswordResetSuccess = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    let appName = searchParams.get("appName")

 
    if (appName == "RE:SURE"){
        appName = "RESURE"
    }
    if (appName == "Magnum Security" || appName == "MAGNUM_SECURITY"){
        appName = "Magnum"
    }

    let logoMapping = [
        knowioLogo, 
        resureLogo, 
        parfasLogo, 
        magnumLogo, 
        portalLogo,
        eesLogo,
        solarLogo,
        cscLogo,
        siteGuardLogo, 
        crimeGuardLogo,
        siteGuardianLogo,
        redLogo
    ]

    let icon;

    switch (appName){
        case "RESURE":
            icon = logoMapping[1]
        break;
        case "KNOWIO":
            icon = logoMapping[0]
        break;
        case "Magnum":
            icon = logoMapping[3]
        break;
        case "PORTAL_SECURITY":
            icon = logoMapping[4]
        break;
        case "PARFAS":
            icon = logoMapping[2]
        break;
        case "EES":
            icon = logoMapping[5]
        break;
        case "SOLAR":
            icon = logoMapping[7]
        break;
        case "CSC":
            icon = logoMapping[8]
        break;
        case "SITEGUARD":
            icon = logoMapping[9]
        break;
        case "CRIMEGUARD":
            icon = logoMapping[10]
        break;
        case "SITEGUARDIAN":
            icon = logoMapping[11]
        break;
        case "RED":
            icon = logoMapping[12]
        break;
    }

    return (
        <div className={`${styles.container} ${styles[appName]}`}>
            <div className={`${styles.card} ${styles[appName]}`}>
                <img style={{width: "100px", height:"100px", borderRadius:"10px"}} src={icon}></img>
                <h1 className={styles.title}>Password reset successfully! 🎉</h1>
                <p className={styles.subTitle}>You can now log into the Portal</p>
            <br></br>
                
                    <a href="https://portal.inniovate.com" style={{ padding: "10px 20px", background: "#007bff", color: "white", borderRadius: "5px", textDecoration: "none" }}>
                        Back to Portal
                    </a>
                
                <br></br>
            </div>
        </div>
    );
};

export default PortalPasswordResetSuccess;
